import React from 'react'
import { Language } from '../types'

/**
 * Used to pass down the language
 */
export const LanguageContext = React.createContext<Language>('de')
